const VID_KEY = "app_vid";

function getVid() {
  let vid = localStorage.getItem(VID_KEY);
  if (!vid) {
    vid = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(VID_KEY, vid);
  }
  return vid;
}

export default function track(event, path, meta) {
  try {
    if (typeof navigator !== "undefined" && navigator.webdriver) return;
    const p = path || window.location.pathname;
    if (p.startsWith("/admin")) return;
    const payload = { event, path: p, vid: getVid(), width: window.innerWidth, meta: meta || null };
    if (event === "pageview") payload.referrer = document.referrer || null;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch (e) { /* fire-and-forget */ }
}
